import {createAction} from 'redux-actions'
export const setAuth = createAction("SET_AUTH");
